import { render, staticRenderFns } from "./research-index.vue?vue&type=template&id=196abb0d&"
import script from "./research-index.vue?vue&type=script&lang=js&"
export * from "./research-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports